export default "__VITE_ASSET__znI_HXTf__"